<template>
  <div :class="classNames">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'ZjWorkSpace',
  componentName: 'ZjBody',
  data() {
    return {
      scrollable: false
    }
  },
  computed: {
    classNames() {
      return {
        'zj-body': true,
        'scrollable': this.scrollable
      }
    }
  },
  created() {
    this.$on('scrollable', this.onScrollable);
  },
  methods: {
    onScrollable(e) {
      console.log(e);
    }
  }
}
</script>
